import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import ApiInterface from '@/plugins/ApiInterface'

class Api implements ApiInterface {
  private axios: AxiosInstance

  constructor() {
    this.axios = axios.create({
      baseURL: process.env.VUE_APP_BASE_URL
    })
  }

  async get<T>(url: string, params?: object): Promise<T> {
    return await this.sendResponse<T>('get', url, null, params)
  }

  async post<T>(url: string, data?: any, params?: object): Promise<T> {
    return await this.sendResponse<T>('post', url, data, params)
  }

  private sendResponse<T, R = null>(
    method: 'get' | 'post' | 'put' | 'delete' | 'patch',
    url: string,
    data?: R,
    params?: object
  ): Promise<T> {
    return this.axios
      .request({
        method,
        url,
        data,
        params
      } as AxiosRequestConfig)
      .then((response: AxiosResponse) => {
        return response.data
      })
      .catch((e: AxiosError) => {
        throw e
      })
  }
}

export default new Api()
